import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import { FetchCartDocument, type FetchCartQuery } from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

export const fetchCart =
  (options: GlobalRequestOptions) =>
  async (id: string): Promise<Cart> => {
    const response = await storefrontClient.request<FetchCartQuery>(print(FetchCartDocument), {
      variables: {
        id,
        language: options.language,
        country: options.country,
      },
    })

    if (!response.data) {
      throw new Error('Failed to fetch cart')
    }

    if (!response.data.cart) {
      throw new Error('Failed to fetch cart')
    }

    return mapGQLCartToCart(response.data.cart)
  }
